import ProductFilter from './frontoffice/ProductFilter';
customElements.define('product-filter', ProductFilter,{extends: 'div'});

import ProductCard from './frontoffice/ProductCard';
customElements.define('product-card', ProductCard,{extends: 'div'});